
__webpack_require__.S = {};
__webpack_require__.initializeSharingData = { scopeToSharingDataMapping: { "default": [{ name: "@anova/auth-routing", version: "6.3.0", factory: () => (__webpack_require__.e("3686").then(() => (() => (__webpack_require__(89045))))), eager: 0 }, { name: "@anova/auth-service", version: "6.2.3", factory: () => (__webpack_require__.e("8425").then(() => (() => (__webpack_require__(70304))))), eager: 0 }, { name: "@anova/auth-state", version: "6.2.3", factory: () => (__webpack_require__.e("1622").then(() => (() => (__webpack_require__(43280))))), eager: 0 }, { name: "@anova/crude-theme-provider", version: "88.0.0", factory: () => (__webpack_require__.e("5278").then(() => (() => (__webpack_require__(25752))))), eager: 0 }, { name: "@anova/moment", version: "88.0.0", factory: () => (__webpack_require__.e("3542").then(() => (() => (__webpack_require__(37488))))), eager: 0 }, { name: "@emotion/css", version: "11.13.5", factory: () => (__webpack_require__.e("7650").then(() => (() => (__webpack_require__(55913))))), eager: 0 }, { name: "@emotion/react", version: "11.14.0", factory: () => (__webpack_require__.e("8614").then(() => (() => (__webpack_require__(33701))))), eager: 0 }, { name: "@emotion/styled", version: "11.14.1", factory: () => (__webpack_require__.e("7451").then(() => (() => (__webpack_require__(22278))))), eager: 0 }, { name: "history@^5", version: "5.3.0", factory: () => (__webpack_require__.e("8868").then(() => (() => (__webpack_require__(43706))))), eager: 0 }, { name: "history@^5", version: "5.3.0", factory: () => (__webpack_require__.e("3845").then(() => (() => (__webpack_require__(58836))))), eager: 0 }, { name: "moment", version: "2.29.4", factory: () => (__webpack_require__.e("9527").then(() => (() => (__webpack_require__(95093))))), eager: 0 }, { name: "react-dom", version: "17.0.2", factory: () => (() => (__webpack_require__(40961))), eager: 1 }, { name: "react-helmet-async", version: "2.0.5", factory: () => (__webpack_require__.e("7539").then(() => (() => (__webpack_require__(85902))))), eager: 0 }, { name: "react-router-dom-v5-compat", version: "6.30.3", factory: () => (__webpack_require__.e("7098").then(() => (() => (__webpack_require__(39937))))), eager: 0 }, { name: "react-router-dom", version: "5.3.0", factory: () => (__webpack_require__.e("1946").then(() => (() => (__webpack_require__(54625))))), eager: 0 }, { name: "react-router@^6", version: "6.14.1", factory: () => (__webpack_require__.e("981").then(() => (() => (__webpack_require__(54148))))), eager: 0 }, { name: "react-router@^6", version: "6.14.1", factory: () => (__webpack_require__.e("7463").then(() => (() => (__webpack_require__(19743))))), eager: 0 }, { name: "react", version: "17.0.2", factory: () => (() => (__webpack_require__(96540))), eager: 1 }, { name: "recoil", version: "0.4.1", factory: () => (__webpack_require__.e("6257").then(() => (() => (__webpack_require__(25176))))), eager: 0 }, { name: "styled-system", version: "5.1.5", factory: () => (__webpack_require__.e("4759").then(() => (() => (__webpack_require__(66010))))), eager: 0 }, 77328, 88965, 47533, 83921, 54702, 69063, 28209, 60858, 87909, 51089] }, uniqueName: "frontend.anova-base" };
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if (!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if (!initToken) initToken = initTokens[name] = {};
	if (initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if (initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if (!__webpack_require__.o(__webpack_require__.S, name))
		__webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function (msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = __webpack_require__.initializeSharingData.uniqueName;
	var register = function (name, version, factory, eager) {
		var versions = (scope[name] = scope[name] || {});
		var activeVersion = versions[version];
		if (
			!activeVersion ||
			(!activeVersion.loaded &&
				(!eager != !activeVersion.eager
					? eager
					: uniqueName > activeVersion.from))
		)
			versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function (id) {
		var handleError = function (err) {
			warn("Initialization of sharing external failed: " + err);
		};
		try {
			var module = __webpack_require__(id);
			if (!module) return;
			var initFn = function (module) {
				return (
					module &&
					module.init &&
					module.init(__webpack_require__.S[name], initScope)
				);
			};
			if (module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if (initResult && initResult.then)
				return promises.push(initResult["catch"](handleError));
		} catch (err) {
			handleError(err);
		}
	};
	var promises = [];
	var scopeToSharingDataMapping = __webpack_require__.initializeSharingData.scopeToSharingDataMapping;
	if (scopeToSharingDataMapping[name]) {
		scopeToSharingDataMapping[name].forEach(function (stage) {
			if (typeof stage === "object") register(stage.name, stage.version, stage.factory, stage.eager);
			else initExternal(stage)
		});
	}
	if (!promises.length) return (initPromises[name] = 1);
	return (initPromises[name] = Promise.all(promises).then(function () {
		return (initPromises[name] = 1);
	}));
};

